import React from "react";
import { useClarificationTypes } from "newui/store/common-types";
import {
	SelectWithLabel,
	BaseSelectWithLabelProps,
	SelectOption,
} from "../InputWithLabel/SelectWithLabel";

/**
 * Common select for clarification types — backed by the cached
 * `clarification_types` lookup. Used by both the RFx-level Clarifications
 * modal (`ClientCreation`) and the panel-member clarification form on the
 * Evaluation flow so the two surfaces stay in sync.
 */
export const ClarificationTypeSelect = ({
	label = "Type",
	placeholder = "Select type",
	...rest
}: Omit<BaseSelectWithLabelProps, "options" | "isLoading">) => {
	const { values, isLoading } = useClarificationTypes();
	return (
		<SelectWithLabel
			options={values as SelectOption[]}
			isLoading={isLoading}
			label={label}
			placeholder={placeholder}
			{...rest}
		/>
	);
};
